<template>
  <div class="paperds">
    <!-- 论文详情 -->
    <div class="centent">
      <div class="cen_lives">
        <h3 style="cursor: default">{{ data_list.title }}</h3>
        <ul>
          <li style="cursor: default" v-for="(item, index) in titles_lives">
            <div v-if="titl_center[index] == ''">
              {{ item }}
            </div>
            <div v-else>
              <Tooltip :content="titl_center[index]" placement="top">
                {{ item }}
              </Tooltip>
            </div>
          </li>
          <!-- <li style=" cursor:default; ">{{data_list.articleAuthor}}</li>
                   <li style=" cursor:default; ">{{data_list.articleAuthor}}</li> -->
          <!-- <li>魏家才</li>
                   <li>魏家才</li> -->
          <div class="clear"></div>
        </ul>
        <!-- <p style=" cursor:default; ">{{data_list.organizer}}</p> -->
      </div>
      <div class="algins">
        <div class="fl">
          发表刊物：<span v-if="data_list.periodicalName">{{
            data_list.periodicalName
          }}</span
          ><span v-if="data_list.periodicalPeriodName"
            >（{{ data_list.periodicalPeriodName }}）</span
          >
        </div>
        <div class="fr">
          <p style="float: left; padding-right: 10px; line-height: 40px">分享至</p>
          <share style="float: left" :config="config"></share>
        </div>
        <div class="clear"></div>
      </div>
      <div class="color_wis">
        <div class="abstract">
          <span>摘要</span>:
          <p class="next_lives" style="display: inline" v-html="data_list.summary"></p>
        </div>
        <div class="abstract" style="margin-top: 20px">
          <span>关键词</span>：【{{ data_list.articleKey }}】
        </div>

        <div class="fle_lives">
          <!--  -->
          <div class="marlives" v-if="data_list.pdfPath == '' ? false : true">
            <div class="text_title" style="margin-right: 15px" @click="reading()">
              在线阅读
            </div>
            <!-- -->
            <div class="text_title" @click="pdfdows()" style="margin-left: 15px">
              下载
            </div>
            <div class="clear"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import pepares from "@/api/common-header.js";
import Common from "@/api/common";
import pdfdow from "@/api/contribution";
export default {
  name: "paperds",
  data() {
    return {
      userInfo: JSON.parse(sessionStorage.getItem("userInfo"))
        ? JSON.parse(sessionStorage.getItem("userInfo")).userInfo
        : "",
      config: {
        url: window.location.href, // 网址，默认使用 window.location.href
        // source              : '', // 来源（QQ空间会用到）, 默认读取head标签：<meta name="site" content="http://overtrue" />
        // title : localStorage.getItem('name'), // 标题，默认读取 document.title 或者 <meta name="title" content="share.js" />
        // description         : '', // 描述, 默认读取head标签：<meta name="description" content="PHP弱类型的实现原理分析" />
        // image               : '', // 图片, 默认取网页中第一个img标签
        sites: ["qq", "wechat", "weibo"], // 启用的站点
        // disabled            : ['google', 'facebook', 'twitter'], // 禁用的站点
        wechatQrcodeTitle: "微信扫一扫：分享", // 微信二维码提示文字
        wechatQrcodeHelper:
          "<p>微信里点“发现”，扫一下</p><p>二维码便可将本文分享至朋友圈。</p>",
      },
      id_lives: " ",
      data_list: [],
      listdata: false,
      imgUrl: Common.imgUrl,
      stimes: Common.stimes,
      token: " ",
      useinfo: " ",
      titles_lives: [],
      titl_center: [],
    };
  },
  created() {
    this.id_lives = this.$route.query.id;
  },
  mounted() {
    this.new_lives();
  },

  methods: {
    //   this.id_lives
    new_lives() {
      var params = {
        articleId: this.id_lives,
      };
      pepares.defense(params).then((res) => {
        this.data_list = res.periodReadList[0];

        document.title = res.periodReadList[0].title;
        //    var nvars=res.periodReadList[0].summary;
        var next_name = res.periodReadList[0].articleAuthor;
        var next_centers = res.periodReadList[0].companyName;
        this.titles_lives = next_name.split(",");
        this.titl_center = next_centers.split(",");
        // this.titles_lives=next_name.replace(/,/g," ");
        //   localStorage.setItem('name',res.periodReadList[0].title)
        //  this.config.title=res.periodReadList[0].title;
      });
    },
    //在线预览
    reading() {
      // this.token = sessionStorage.getItem("token");
      // if (this.token) {
      window.open(this.imgUrl + this.data_list.pdfPath, "_blank");
      // } else {
      //   // window.location.href =
      //   // process.env.VUE_APP_API_URL +
      //   // `/tsg-author/logout?Authorization=${that.token}&isbk=true`;

      //   window.location.href =
      //     process.env.VUE_APP_API_URL +
      //     "/tsg-author/pageRedirect?path=paperds?id=" +
      //     this.id_lives;
      // }
    },
    pdfdows() {
      this.token = sessionStorage.getItem("token");
      if (this.token) {
        window.location.href =
          this.stimes +
          `/tsg-author/web/download/downloadArticlePDF?articleId=${
            this.id_lives
          }&userId=${this.userInfo.userId}&ipAddr=${""}&mobile=${
            this.userInfo.mobile
          }&nickname=${this.userInfo.realname}`;
      } else {
        this.$Message.destroy();
        this.$Message.error("请登录后再下载");
        this.$root.Bus.$emit("analy", true);
      }
    },
  },
};
</script>

<style scoped lang="less">
.centent {
  width: 1200px;
  margin: 0 auto;
  text-align: center;
}
.cen_lives h3 {
  margin-top: 96px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 28px;
}
.cen_lives p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3e3e3e;
  line-height: 28px;
  // margin-top: 18px;
}
.cen_lives ul {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #3e3e3e;
  line-height: 28px;
  text-align: center;
  display: inline-block;
  margin-top: 20px;
}
.cen_lives ul li {
  padding: 0px 7px;
  list-style: none;
  float: left;
}
.clear {
  clear: both;
}
.algins {
  padding: 35px 5px 10px 20px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #3e3e3e;
  line-height: 28px;
}
.algins .fl {
  float: left;
  cursor: default;
}
.algins .fr {
  float: right;
}
.color_wis {
  background: #ffffff;
  padding: 35px;
  min-height: 500px;
  position: relative;
}
.abstract {
  text-align: left;
  font-size: 14px;
  font-family: Microsoft YaHei;
  color: #333333;
  line-height: 28px;
}
.abstract span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 28px;
}
.fle_lives {
  width: 100%;
  position: absolute;
  left: 0px;
  bottom: 50px;
}
.marlives {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #171ce3;
  line-height: 24px;
  margin: 0 auto;
  cursor: pointer;
  max-width: 200px;
}
.text_title {
  float: left;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  // color: #171CE3;
  line-height: 24px;
  padding: 7px 15px;
  border: 2px solid #285af8;
  border-radius: 20px;
  font-weight: 400;
  color: #171ce3;
}
.text_title:hover {
  background: #c7dcff;
}
.next_lives /deep/ span {
  font-weight: normal !important;
  font-size: 14px !important;
}
.social-share * {
  font-family: "socialshare" !important;
}

.social-share /deep/ .icon-qq:before {
  content: "\F11A" !important;
}
</style>
